<template>
    <div>
        <div v-if="images.length" class="images sidebar__block">
            <div class="images__title">Images:</div>
            <div class="r-touchComponent">
                <ul id="touchParent" class="">
                    <li v-for="(image, index) in images">
                        <a href="javascript:void(0)" v-on:click="popupAttachment(image.url)"><img :src="image.url"></a>
                    </li>
                </ul>
            </div>
        </div>

        <div v-if="videos.length" class="videos sidebar__block" style="padding:20px 10px 15px 25px;">
            <div class="sidebar__title">Videos:</div>
            <div class="video_results vid-list--short">
                <div v-for="(video, index) in videos" class="video_result">
                    <div class="video_image"><a href="javascript:void(0)" v-on:click="popupVideoModal(video.url)"><img :src="play"></a>
                        <div class="video_len">{{ video.duration }}</div>
                    </div>
                    <div class="video_text">
                        <div class="video_title"><a href="javascript:void(0)">{{ video.title }}</a></div>
                        <div class="video_source">{{ video.post.category.name }}</div>
                    </div>
                </div>
            </div>
            <video-modal ref="modal" :full_url="url"></video-modal> 
        </div>

        <div v-if="files.length" class="related sidebar__block">
            <div class="related__section related--short">
                <div class="sidebar__title">Files:</div>
                <div v-for="(file, index) in files" class="related__item">
                    <a href="javascript:void(0)" v-on:click="popupAttachment(file.url)">
                        {{ file.title }}          
                    </a>
                </div>
            </div>
        </div>  

    </div>
</template>

<script>
    import VideoModal from './../VideoModal.vue';
    export default {
        props: ['data'],
        components:{
            VideoModal
        },
        data() {
            return {
                attachments: [],
                images: [],
                videos: [],
                files: [],
                play: "",
                url: "",
            };
        },
        mounted() {
            this.getPostAttachments(this.data.post_id);
        },    
        methods: {
            getPostAttachments(id) {
                const form = new FormData();
                form.append('id', id);
                axios.post('/api/ajax/posts/attachments', form)
                .then(res => {
                    this.attachments = res.data.data.attachments;
                    this.images = res.data.data.images;
                    this.videos = res.data.data.videos;
                    this.files = res.data.data.files;
                    this.play = res.data.data.play;
                })
                .catch(err => {  
                    console.log(err);                  
                });
            },
            popupAttachment(url) {
                const form = new FormData();
                form.append('type', 'file');
                form.append('post_id', this.data.post_id);
                axios.post('/api/ajax/posts/hit', form)
                .then(res => {
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(err => {  
                    console.log(err);                  
                }); 
            },
            popupVideoModal(url) {
                var video = document.getElementById('videoId');
                video.src = url;
                let element = this.$refs.modal.$el;
                $(element).modal('show');
                video.load();
                setTimeout(function() {
                    video.play();
                }, 0);
            },
        },       
    }
</script>